
function Slider() {

  return (
    <div className="container-fluid p-0 pt-3 mt-5 py-1 bg-dark">
      <img src="/images/int.jpeg" alt="banner"
        className="position-relative  w-100 text-center mx-auto d-block"
        style={{ height: "350px"}}
        />
    </div>
  );
}

export default Slider;